import { getLocale } from "./locale";

export async function apiFetch(url, options = {}) {
  const headers = {
    "Accept-Language": getLocale(),
    ...(options.headers || {}),
  };
  return fetch(url, { ...options, headers });
}
